import React, { useState, useEffect } from 'react';
import Fetch from '../../../../../core/util/core/Fetch';
import config from '../../../../config/config';
import { useSelector } from 'react-redux';
import EntityProjectsContext from '../EntityProjects/context/EntityProjects.context';

import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from 'reactstrap';
import classnames from "classnames";

import '../home/Home.css';

const SelectionProcess = (props) => {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const [selectionProcesses, setSelectionProcesses] = useState('')

  useEffect(() => {
    const loadData = async () => {
      const selectionProcessesData = await Fetch.post(`${config.endpoints.backend}portal/getallselectionprocesses`, { filter: { friendly_url } })

      setSelectionProcesses(selectionProcessesData)
    };

    loadData();
  }, [])

  const [open, setOpen] = useState('0');
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    (selectionProcesses && selectionProcesses.length > 0 && selectionProcesses != '') ? (
      <div className='ml-4 mt-3 mr-4 pt-3 height-100vh'>
        <Accordion open={open} toggle={toggle}>
          {selectionProcesses.map((process, index) => (
            <AccordionItem
              key={index}
              className={classnames({ open: open === String(index), closed: open !== String(index) })}
            >
              <AccordionHeader targetId={String(index)}>
                Edital Nº {process.edital_number} - {process.title}
              </AccordionHeader>
              <AccordionBody accordionId={String(index)}>
                {process.description}
                <br />
                <span>Anexos:</span>
                <ul>
                  {process.files.map((file, indexFile) => (
                    <li key={indexFile}>
                      <a href={file.files3} download={true} target="_blank">
                        {file.filename}
                      </a>
                    </li>
                  ))}
                </ul>
              </AccordionBody>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    ) : (
      <div className='ml-4 mt-3 mr-4 pt-1 height-100vh'>
        <Accordion className='mt-3' open={open}>
          <AccordionItem
            key={0}
            className={classnames({ open: open === String(0), closed: open !== String(0) })}
          >
            <AccordionHeader targetId={String(0)}>
              Processos Seletivos
            </AccordionHeader>
            <AccordionBody accordionId={String(0)}>
              Não existe nenhum processo seletivo para esse projeto
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </div>
    )
  );
};

export default SelectionProcess;